import { LANGS, useLang } from "@/lib/i18n";

export const LangSwitcher = ({ className = "" }) => {
  const { lang, setLang, t } = useLang();
  return (
    <div role="group" aria-label={t.nav.language} className={`flex items-center gap-1 ${className}`}>
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          data-testid={`lang-option-${l.code}`}
          aria-pressed={l.code === lang}
          title={l.label}
          onClick={() => setLang(l.code)}
          className={`px-2.5 py-1 font-mono text-[11px] font-medium uppercase tracking-[0.12em] transition-colors duration-300 ${l.code === lang ? "bg-ink text-bone" : "text-ink hover:bg-ink/15"}`}
        >
          {l.code === "en" ? "English" : l.label}
        </button>
      ))}
    </div>
  );
};
